/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_PRODUCT_PAGE_DATA: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.ProductPage.get-product-page-data',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_PRODUCT_PAGE_DATA' },
      },
    },
    GET_PRODUCT_PAGE_DATA: {
      invoke: {
        id: 'getProductPageData',
        src: 'getProductPageData',
        onDone: {
          target: 'RENDER_PRODUCT_PAGE_DATA',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_PRODUCT_PAGE_DATA_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_PRODUCT_PAGE_DATA: {
      type: 'final',
    },
    RENDER_PRODUCT_PAGE_DATA_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
